import { z } from 'zod'

// one held instrument's projected 12-month income for a SINGLE lot (lot-size units), independent of
// how many the user currently holds. powers the "buy one lot" decision table on the Income tab.
// gross is the sum, over the next 12 months, of projected dividends + still-buyable announced
// dividends (stocks) or the future coupon schedule (bonds). amounts are in the instrument currency;
// the frontend converts to ₽ and applies the dividend tax rate for the net figure.
export const incomeProjectionRowSchema = z.object({
  instrumentUid: z.string(),
  figi: z.string().nullable(),
  ticker: z.string().nullable(),
  instrumentName: z.string().nullable(),
  // lowercase T-Bank instrument kind ('share' | 'bond')
  instrumentType: z.string(),
  // instrument currency the gross/lot-price amounts are denominated in
  currency: z.string().nullable(),
  lotSize: z.number(),
  // current market price of one lot in the instrument currency (currentPrice × lotSize); 0 when the
  // price is unknown, in which case the yield is omitted.
  lotPrice: z.number(),
  // 12-month gross income for one lot in the instrument currency
  grossPerLot: z.number(),
})

export type IncomeProjectionRowDto = z.infer<typeof incomeProjectionRowSchema>

export const incomeProjectionResponseSchema = z.object({
  // one row per held instrument with positive projected income, sorted by gross descending
  rows: z.array(incomeProjectionRowSchema),
})

export type IncomeProjectionResponseDto = z.infer<typeof incomeProjectionResponseSchema>
